// extracted by mini-css-extract-plugin
export var stickyWrapper = "header-module--sticky-wrapper--wI4-5";
export var isSticky = "header-module--is-sticky--1dZmf";
export var header = "header-module--header--2GXhr";
export var menuContainer = "header-module--menu-container--LeG3w";